export function CycleMark({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
      <path d="M6 16a10 10 0 0 1 17-7.2" stroke="#FF8C32" strokeWidth="2.6" strokeLinecap="round" />
      <path d="M23 4.4v4.6h-4.6" stroke="#FF8C32" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M26 16a10 10 0 0 1-17 7.2" stroke="#38BDF8" strokeWidth="2.6" strokeLinecap="round" />
      <path d="M9 27.6v-4.6h4.6" stroke="#38BDF8" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function Logo({ compact = false }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="nav-logo">
      <span className="grid h-9 w-9 place-items-center rounded-xl border border-white/10 bg-navy-800 shadow-[0_0_24px_rgba(255,107,0,0.15)]">
        <CycleMark />
      </span>
      {!compact && (
        <div className="leading-none">
          <span className="font-display text-[15px] font-bold tracking-tight text-slate-50">
            CROWSON
          </span>
          <span className="mt-1 block font-mono text-[9px] uppercase tracking-[0.22em] text-forge">
            Home Services
          </span>
        </div>
      )}
    </div>
  );
}
